export const apiUrl =
  'https://us-central1-grommet-designer.cloudfunctions.net/designs';
// export const apiUrl = 'http://localhost:8080';
export const themeApiUrl =
  'https://us-central1-grommet-designer.cloudfunctions.net/themes';
